<template>
    <v-footer color="primary" app>
        <span class="white--text">&copy; {{ new Date().getFullYear() }}</span>
        <v-spacer/>
        <span class="white--text">{{ version }}</span>
        <v-spacer/>
        <a class="jagulogo-jagu-line" href="https://jagu.cz/" target="_blank"></a>
    </v-footer>
</template>

<script>
    export default {
        name: 'FooterPartial',
        computed: {
            version() {
                return process.env.VUE_APP_VERSION
            }
        }
    }
</script>

<style lang="scss" scoped>
    .jagulogo-jagu-line {
        color: white;
        text-decoration: none;

        &:before {
            position: relative;
            font-size: 18px;
            top: 3px;
        }
    }

</style>
